import {games} from '../../Components/Home/GamesDetails';
import {Link} from 'react-router-dom';
import './Sidebar.css'

export default function Sidebar () {  
        return (
            <div className='bar'>{games.map(game =>  
                <div>
                    <Link to = {game.url}> 
                        <img className='sidebar_images' src={game.picture} alt={game.name} /> 
                    </Link> 
                </div>)}
            </div>
    );
}